/**
 * Pure routing logic for the initialise-session page. Extracted so it can be
 * unit-tested without a JSX renderer.
 *
 * Priority:
 * 1. Sign-up code present -> route to mint page (Google SSO onboarding path).
 * 2. Track id present -> route to activate-track-id (magic-link / partner path).
 * 3. From query param present -> route to the decoded previous URL.
 * 4. Fallback -> credential setup.
 */
import { ACTIVATE_TRACK_ID_PATH } from '@/pages/activate-track-id';
import { CREDENTIAL_SETUP_PATH } from '@/pages/credentialSetup';
import { SIGN_UP_CODE_MINT_PATH } from '@/pages/sign-up-code/mint';
import { getSignUpCodeFromStorage, getTrackIdFromStorage } from '@/utils/utils';

export function routeFromSession(deps: {
  push: (path: string) => void;
  from: string | undefined;
}) {
  const signUpCode = getSignUpCodeFromStorage();
  if (signUpCode) {
    deps.push(SIGN_UP_CODE_MINT_PATH);
    return;
  }

  const trackId = getTrackIdFromStorage();
  if (trackId) {
    deps.push(ACTIVATE_TRACK_ID_PATH);
    return;
  }

  if (deps.from) {
    deps.push(decodeURIComponent(deps.from));
    return;
  }

  deps.push(CREDENTIAL_SETUP_PATH);
}
